(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["punti-eterea-lovers"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function(){
        const slider = document.querySelector("#swiper-eterea-lovers");
        const swiper = new Swiper(slider, {
            speed: 800,
            spaceBetween: 50,
            effect: "slide",
            slidesPerView: 1,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                768: {
                    spaceBetween: 10,
                    slidesPerView: 2,
                }
            }
        });
    });

  } catch(e) { console.error(e); }
})();
})();
